import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-edit-conversation-name-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './edit-conversation-name-modal.component.html',
  styleUrl: './edit-conversation-name-modal.component.css'
})
export class EditConversationNameModalComponent implements OnInit {
  @Input() currentName = '';
  @Output() saveConfirmed = new EventEmitter<string>();

  editedName = '';

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    this.editedName = this.currentName || '';
  }

  onCancel(): void {
    this.activeModal.dismiss();
  }

  onSave(): void {
    this.saveConfirmed.emit(this.editedName.trim());
  }
}
